import { VideoCarousel } from "./VideoCarousel";
import { BackgroundVideoWatermark } from "./BackgroundVideoWatermark";

// Videos
const NEWS_VIDEO =
  "https://customer-assets.emergentagent.com/job_40b88a96-2e6b-4fee-851f-9538453bd636/artifacts/x0ky5fel_VID-20260614-WA0001.mp4";
export const EVENTS_VIDEO =
  "/event-videography.mp4";

const DOCUMENTARY_ITEMS = [
  { provider: "youtube", id: "bbkWK80O0Y8", title: "Светлая неделя 2022 Спас" },
  { provider: "youtube", id: "7goFsvLj_0Y", title: "Паломничество на Святую Землю - документальный фильм" },
  { provider: "youtube", id: "Z8Fu7vT-lfs", title: "列王紀(上) 第 2 站 王上1-3章 聯合王國（一）- 所羅門登基 | 播種國際事工" },
  { provider: "youtube", id: "KC44Ybnmfv8", title: "Why Israeli Weapons Are in Demand Despite Global Criticism" },
  { provider: "youtube", id: "IYUpYeCO3Dg", title: "Sodom: The God's Punishment. Episode 4: Madaba" },
  { provider: "youtube", id: "24YvHmu--eE", title: "Biblical Mysteries | Expedition Unknown | Discovery" },
];

const NEWS_ITEMS = [
  { provider: "youtube", id: "YyH5ztw4yYk", title: "Hamas' deadly destruction of Kibbutz in Israel" },
  { provider: "youtube", id: "-u-iN3znpFQ", title: "Israele, prima giornata della Marcia per gli ostaggi" },
  { provider: "youtube", id: "KC44Ybnmfv8", title: "Why Israeli Weapons Are in Demand Despite Global Criticism" },
  { provider: "youtube", id: "bW8Nuq3JM5c", title: "Biden visits Israel (14/07/22) Bloomberg" },
  { provider: "youtube", id: "qzwJrawYmlQ", title: "حمله به نهاد ریاست جمهوری، شورای عالی امنیت ملی و مجلس خبرگان رهبری - ۶۰ دقیقه سه‌شنبه ۱۲ اسفند" },
  { provider: "youtube", id: "Ish-fKceXiw", title: "ЦТ 20/04/24" },
  { provider: "youtube", id: "VlTXQaciLz8", title: "НТВ Центральное Телевидение 03/03/18 Война за Храм Гроба Господня" },
  { provider: "youtube", id: "1rudPT4FVAE", title: "Israel: 'All options are being considered' against Iran | Israel-Hamas war" },
];

const EVENT_ITEMS = [
  { provider: "youtube", id: "Tq4C5dz_Mfw", title: "The Eli Hurvitz Conference on Economy and Society 2024: Israel at War | Recap" },
  { provider: "youtube", id: "Hzba7OxgEIE", title: "BlueHat IL 2024 Recap" },
  { provider: "vimeo", id: "966149669", hash: "dcf76a696e", title: "Conference reel" },
  { provider: "vimeo", id: "1011377913", hash: "284b68791f", title: "Plarium" },
];

const SectionHeader = ({ index, title, sub, body }) => (
  <div className="mb-12 md:mb-16">
    <div className="reveal mb-14 md:mb-20 max-w-md">
      <div className="font-sans text-[11px] uppercase tracking-[0.4em] text-[#C5A059] font-light">
        {index}
      </div>
    </div>
    <div className="grid grid-cols-12 gap-6 md:gap-10">
      <div className="hidden md:block md:col-span-3" aria-hidden="true" />
      <div className="col-span-12 md:col-span-9 reveal">
        <h2 className="font-display tracking-tight leading-[1.02] text-4xl sm:text-5xl md:text-6xl text-white">
          {title}
          {sub && <span className="block text-white/65 font-extralight">{sub}</span>}
        </h2>
        {body && (
          <p className="mt-6 max-w-2xl font-sans text-white/65 text-base leading-relaxed font-light">
            {body}
          </p>
        )}
      </div>
    </div>
  </div>
);

const WorkBlock = ({ id, testId, videoSrc, overlayClass, children }) => (
  <section id={id} data-testid={testId} className="relative w-full overflow-hidden bg-black">
    <video
      src={videoSrc}
      className="absolute inset-0 w-full h-full object-cover"
      autoPlay
      muted
      loop
      playsInline
      aria-hidden="true"
    />
    <div aria-hidden="true" className={`absolute inset-0 ${overlayClass}`} />
    <BackgroundVideoWatermark />
    <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10 py-24 md:py-36">
      {children}
    </div>
  </section>
);

export const WorkSections = () => {
  return (
    <div id="work">
      {/* 01 — Documentary Films */}
      <WorkBlock
        id="documentary"
        testId="work-documentary"
        videoSrc={NEWS_VIDEO}
        overlayClass="bg-gradient-to-b from-black/85 via-black/70 to-black/85"
      >
        <SectionHeader
          index="01 — Documentary"
          title="Documentary Films"
          sub="& Factual Programs"
          body="Documentary films and factual programs focused on society, history, archaeology and religion. Research, development, field production and final delivery — grounded in accuracy and strong editorial standards."
        />
        <div className="reveal">
          <VideoCarousel items={DOCUMENTARY_ITEMS} testIdPrefix="documentary-carousel" />
        </div>
      </WorkBlock>

      {/* 02 — News Coverage */}
      <WorkBlock
        id="news"
        testId="work-news"
        videoSrc={NEWS_VIDEO}
        overlayClass="bg-gradient-to-b from-black/90 via-black/75 to-black/90"
      >
        <SectionHeader
          index="02 — News"
          title="News Coverage"
          sub="& Research"
          body="Full-service news production support — research of speakers and locations, field production, filming and live broadcast coordination. Trusted by international broadcasters and media organisations."
        />
        <div className="reveal">
          <VideoCarousel items={NEWS_ITEMS} testIdPrefix="news-carousel" />
        </div>
      </WorkBlock>

      {/* 03 — Event Videography */}
      <WorkBlock
        id="events"
        testId="work-events"
        videoSrc={EVENTS_VIDEO}
        overlayClass="bg-gradient-to-b from-black/80 via-black/60 to-black/85"
      >
        <SectionHeader
          index="03 — Events"
          title="Event Videography"
          sub="& Live Coverage"
          body="Professional event videography with a cinematic and unobtrusive style — corporate gatherings, conferences and private celebrations. On-site filming, live streaming and drone coverage."
        />
        <div className="reveal">
          <VideoCarousel items={EVENT_ITEMS} testIdPrefix="events-carousel" />
        </div>
      </WorkBlock>
    </div>
  );
};
